module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Bold-WebXL-c354fbd196527154abe4be33f952d0c3.woff2";